import PropTypes from 'prop-types'
import React, { forwardRef } from 'react'
import Modal from '../Modal/Modal'
import StdButton from '../StdButton/StdButton'

const AcceptDeclineModal = forwardRef(
  (
    {
      acceptButtonTitle,
      children,
      declineButtonTitle,
      onAccept,
      onDecline,
      parent,
      title,
      visible,
    },
    ref
  ) => {
    const { acceptBtnRef, declineBtnRef } = ref

    return (
      <div className={`vppa-modal ${visible ? 'visible' : ''}`}>
        <Modal error={true}>
          <h1>{title}</h1>
          <div className="modal-content">{children}</div>
          <StdButton
            parent={parent}
            disabled={!visible}
            visible={true}
            label={acceptButtonTitle}
            link={false}
            componentType="goBackButton"
            onClick={onAccept}
            preventReadTextOnEvent={true}
            ref={acceptBtnRef}
          >
            {acceptButtonTitle}
          </StdButton>
          <StdButton
            parent={parent}
            disabled={!visible}
            visible={true}
            label={declineButtonTitle}
            link={false}
            componentType="declineVppaConfirmButton"
            onClick={onDecline}
            preventReadTextOnEvent={true}
            ref={declineBtnRef}
          >
            {declineButtonTitle}
          </StdButton>
        </Modal>
      </div>
    )
  }
)

AcceptDeclineModal.displayName = 'AcceptDeclineModal'

AcceptDeclineModal.propTypes = {
  acceptButtonTitle: PropTypes.string,
  children: PropTypes.node,
  declineButtonTitle: PropTypes.string,
  onAccept: PropTypes.func,
  onDecline: PropTypes.func,
  parent: PropTypes.any,
  title: PropTypes.string,
  visible: PropTypes.bool,
}

export default AcceptDeclineModal
